/**
 * Версия собранного фронтенда. Задаётся при сборке (vite.config.mts, плагин `appVersion` из `@srm/core`) тем
 * же значением, что пишется в version.json, — по их расхождению вкладка понимает, что сервер обновили. В dev — 'dev'.
 *
 * typeof — потому что константу подставляет только основной конфиг Vite: Storybook и VR-тесты
 * собираются своими конфигами, и голое обращение там падало бы ReferenceError на импорте.
 */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';
